import React from "react";

const DeleteConfirmModal = ({ show, type = "item", value = "", warning = "", confirming = false, onClose, onConfirm }) => {
  if (!show) return null;
  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 2000,
        background: "rgba(15,23,42,0.4)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff", borderRadius: 14, padding: "28px 28px 20px",
          maxWidth: 380, width: "90%", boxShadow: "0 8px 32px rgba(15,23,42,0.18)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h6 style={{ fontWeight: 700, fontSize: 16, color: "#0f172a", margin: "0 0 8px" }}>
          Delete {type}?
        </h6>
        <p style={{ fontSize: 13, color: "#64748b", margin: warning ? "0 0 8px" : "0 0 20px" }}>
          Are you sure you want to delete <strong>{value}</strong>? This action cannot be undone.
        </p>
        {warning && (
          <p style={{ fontSize: 12.5, color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "8px 10px", margin: "0 0 20px" }}>
            {warning}
          </p>
        )}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button
            className="btn btn-light"
            style={{ fontSize: 13, borderRadius: 8 }}
            onClick={onClose}
            disabled={confirming}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger"
            style={{ fontSize: 13, borderRadius: 8 }}
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
